import {Redirect} from "react-router-dom";
import {PrivateRouteWithLayout} from "../components";
import {
    ChildScore as ChildScorePage, ParentRecommendations as ParentRecommendationsPage,
    ReportOverviewParent as ReportOverviewParentPage,
    ReportOverviewSchool as ReportOverviewSchoolPage
} from "../pages/SchoolDashboardR2";
import {Main as MainLayout} from "../layouts";
import React from "react";

export default [
    <Redirect
        exact
        from={`/:lc/home`}
        to={`/:lc/school/home`}
    />,

    <Redirect
        exact
        from={`/:lc/school/home`}
        to={`/:lc/parent/report_overview`}
    />,

    <PrivateRouteWithLayout
        component={ReportOverviewParentPage}
        exact
        layout={MainLayout}
        path={`/:lc/parent/report_overview`}
    />,

    <PrivateRouteWithLayout
        component={ChildScorePage}
        exact
        layout={MainLayout}
        path={`/:lc/parent/child_score`}
    />,

    <PrivateRouteWithLayout
        component={ParentRecommendationsPage}
        exact
        layout={MainLayout}
        path={`/:lc/parent/recommendations`}
    />,
]